module.exports = __webpack_public_path__ + "img/fs-banner-catalogue.b836a97a.svg";